<app-modal-form #modal [modalConfig]="modalConfig" [modalOptions]="modalOptions">
  <app-section-loader *ngIf="isLoading" class="modal-hadiah-lainnya__loader" />

  <app-card-empty
    *ngIf="hasError"
    [icon]="STRING_CONSTANTS.ICON.IC_REWARD"
    text="Data hadiah tidak dapat dimuat."
  />

  <!-- Defensif: link pemicu hanya muncul saat `other_reward_count > 0`, tapi respons bisa kosong. -->
  <app-card-empty
    *ngIf="isEmpty"
    [icon]="STRING_CONSTANTS.ICON.IC_REWARD"
    text="Belum terdapat hadiah didapatkan."
  />

  <div *ngIf="!isLoading && !hasError && !isEmpty" class="modal-hadiah-lainnya__body">
    <!-- [AC-02] Akumulasi seluruh tingkat yang sudah dicapai distributor. -->
    <div class="modal-hadiah-lainnya__summary">
      <div class="modal-hadiah-lainnya__row">
        <span class="modal-hadiah-lainnya__label">Total QTY Hadiah</span>
        <span class="modal-hadiah-lainnya__separator">:</span>
        <span class="modal-hadiah-lainnya__value">{{ summary?.total_qty }}</span>
      </div>
      <div class="modal-hadiah-lainnya__row">
        <span class="modal-hadiah-lainnya__label">Total Estimasi Budget</span>
        <span class="modal-hadiah-lainnya__separator">:</span>
        <span class="modal-hadiah-lainnya__value">{{ summary?.total_estimated_budget }}</span>
      </div>
    </div>

    <!-- [AC-02] Breakdown hanya tingkat yang dikirim backend — tingkat tanpa hadiah dilewati. -->
    <ng-container *ngFor="let reward of rewards">
      <span class="modal-hadiah-lainnya__heading">Hadiah {{ reward.level }}</span>

      <div class="modal-hadiah-lainnya__group">
        <div class="modal-hadiah-lainnya__row">
          <span class="modal-hadiah-lainnya__label">Hadiah</span>
          <span class="modal-hadiah-lainnya__separator">:</span>
          <span class="modal-hadiah-lainnya__value">{{ reward.reward }}</span>
        </div>
        <div class="modal-hadiah-lainnya__row">
          <span class="modal-hadiah-lainnya__label">QTY Didapatkan</span>
          <span class="modal-hadiah-lainnya__separator">:</span>
          <span class="modal-hadiah-lainnya__value">{{ reward.qty }}</span>
        </div>
        <div class="modal-hadiah-lainnya__row">
          <!-- [QA 28 Agu 2026] Nama tingkat turun ke baris kedua, sesuai design node
               8822-41361: line 1 "Total Estimasi Budget", line 2 "Tingkat N". -->
          <span class="modal-hadiah-lainnya__label"
            >Total Estimasi Budget<br />{{ reward.level }}</span
          >
          <span class="modal-hadiah-lainnya__separator">:</span>
          <span class="modal-hadiah-lainnya__value">{{ reward.total_estimated_budget }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</app-modal-form>
